<mat-calendar #calendar
              class="distribution-classes__calendar"
              [dateClass]="isSelected"></mat-calendar>
